"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatMapLegend = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var uniqueId_1 = tslib_1.__importDefault(require("lodash/fp/uniqueId"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var omit_1 = tslib_1.__importDefault(require("lodash/fp/omit"));
var utils_1 = require("../../utils");
var HEAT_MAP_LEGEND_WIDTH = 16;
var HEAT_MAP_TEXT_WIDTH = 55;
var MAX_LEGEND_HEIGHT = 256;
var calculateDY = function (i, endValLabel) {
    if (i === 0) {
        return '1em';
    }
    if (endValLabel) {
        return '0em';
    }
    return '0.25em';
};
var ValueText = function (_a) {
    var stepNumber = _a.stepNumber, value = _a.value, _b = _a.isEndValLabel, isEndValLabel = _b === void 0 ? false : _b, stepHeight = _a.stepHeight;
    return (react_1.default.createElement("text", { x: HEAT_MAP_TEXT_WIDTH - 8, y: stepNumber * stepHeight, fontSize: 12, textAnchor: "end", dy: calculateDY(stepNumber, isEndValLabel), fontFamily: utils_1.theme.fonts.robotoRegular, fill: utils_1.theme.colors.NTDarkGrey[900], style: { userSelect: 'none' } }, value));
};
var HeatMapLegend = (function (_super) {
    tslib_1.__extends(HeatMapLegend, _super);
    function HeatMapLegend(props) {
        var _this = _super.call(this, props) || this;
        _this.HeatMapLegend = null;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.onStepClick = _this.onStepClick.bind(_this);
        _this.onResize = function () { return _this.createAttributes(); };
        _this.state = {
            height: MAX_LEGEND_HEIGHT,
            selectedStep: null,
        };
        return _this;
    }
    HeatMapLegend.prototype.componentDidMount = function () {
        this.createAttributes();
        window.addEventListener('resize', this.onResize, false);
    };
    HeatMapLegend.prototype.componentDidUpdate = function (prevProps) {
        if (!isEqual_1.default(omit_1.default(['children'], prevProps), omit_1.default(['children'], this.props))) {
            this.createAttributes();
        }
    };
    HeatMapLegend.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize, false);
    };
    HeatMapLegend.prototype.onStepClick = function (step) {
        var _a = this.props, _b = _a.onSelectStep, onSelectStep = _b === void 0 ? noop_1.default : _b, data = _a.data;
        var selectedStep = this.state.selectedStep;
        if (selectedStep === step) {
            this.setState({
                selectedStep: null,
            });
            onSelectStep(null);
        }
        else {
            this.setState({
                selectedStep: step,
            });
            onSelectStep(data[step]);
        }
    };
    HeatMapLegend.prototype.createAttributes = function () {
        var newHeight = this.HeatMapLegend && this.HeatMapLegend.clientHeight < MAX_LEGEND_HEIGHT
            ? this.HeatMapLegend.clientHeight
            : MAX_LEGEND_HEIGHT;
        this.setState({
            height: newHeight,
            selectedStep: null,
        });
    };
    HeatMapLegend.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, allowSelection = _a.allowSelection;
        var _b = this.state, selectedStep = _b.selectedStep, height = _b.height;
        var uniqueGradientID = uniqueId_1.default('gradient');
        var stepHeight = height / data.length;
        return (react_1.default.createElement("svg", { style: { height: '100%' }, ref: function (el) { return (_this.HeatMapLegend = el); }, width: HEAT_MAP_TEXT_WIDTH + HEAT_MAP_LEGEND_WIDTH }, data.map(function (step, stepNumber) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("linearGradient", { id: uniqueGradientID + "-" + stepNumber, x1: "0%", y1: "0%", x2: "0%", y2: "100%" }, step.colors.map(function (color) { return (react_1.default.createElement("stop", { offset: color.offset, stopColor: color.color })); })),
            react_1.default.createElement("rect", { y: stepNumber * stepHeight, x: HEAT_MAP_TEXT_WIDTH, width: HEAT_MAP_LEGEND_WIDTH, height: stepHeight, fill: selectedStep !== null && selectedStep !== stepNumber
                    ? '#EAEAEA'
                    : "url(#" + uniqueGradientID + "-" + stepNumber + ")", stroke: "white", onClick: function () { return allowSelection && _this.onStepClick(stepNumber); }, cursor: allowSelection ? 'pointer' : 'inherit' }),
            react_1.default.createElement(ValueText, { value: step.startValLabel, stepNumber: stepNumber, stepHeight: stepHeight }),
            stepNumber === data.length - 1 && (react_1.default.createElement(ValueText, { value: step.endValLabel, stepNumber: data.length, isEndValLabel: true, stepHeight: stepHeight })))); })));
    };
    return HeatMapLegend;
}(react_1.PureComponent));
exports.HeatMapLegend = HeatMapLegend;
